import { render, staticRenderFns } from "./StateAdd.vue?vue&type=template&id=384db825&scoped=true&"
import script from "./StateAdd.vue?vue&type=script&lang=js&"
export * from "./StateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384db825",
  null
  
)

export default component.exports